<template>
  <div class="card card-visitors">
    <div class="card-header card-chart-mini">
      <div class="d-flex flex-row align-items-center">
        <img src="../../src/assets/icons/trophy.svg" class="ico-18 mr-2" />
        <span v-if="title">{{ title }}</span>
        <span v-else v-text="$ml.get('rankTitle')"
          >Ranking de Contribuições</span
        >
      </div>
      <div class="chart mt-4">
        <canvas id="chart-visitors"></canvas>
      </div>
    </div>
    <div class="card-body py-0">
      <div class="d-column flex-row">
        <div class="loading d-flex">
          <div v-if="loading" class="c-loader m-2"></div>
          <h6
            v-else
            v-show="!itensRank.length"
            class="p-3"
            v-text="$ml.get('rankingDoesNotHaveEnoughDataYet')"
          >
            O Ranking ainda não tem dados suficientes
          </h6>
        </div>

        <div
          v-for="(item, index) in itensRank"
          :key="index"
          :class="
            'h-profile d-flex py-3 align-items-center ' +
              (itensRank.length == index + 1 ? 'no' : '')
          "
        >
          <div
            class="position-relative align-self-center d-flex align-items-center align-self-center w50"
          >
            <div class="verify" v-show="item.verified">
              <img
                src="../../src/assets/icons/badge-check.png"
                width="16"
                height="16"
              />
            </div>
            <object width="42" height="42" :data="item.avatar" type="image/png">
              <img
                width="42"
                height="42"
                src="../assets/images/default.png"
                alt="Avatar hacker"
              />
            </object>
          </div>
          <a class="ml-2 d-flex align-items-center link-block">
            <div class="align-self-center">
              <h3 v-text="item.username"></h3>
              <p v-if="!idProgram">
                {{ item.score }}
                <span v-text="$ml.get('points')"></span>
              </p>
            </div>
            <div class="rank">
              <span class="p-1"> {{ index + 1 }} °</span>
            </div>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Chart from "chart.js";
import RankingService from "../services/ranking.service";
export default {
  name: "ranking",
  props: {
    title: {
      required: false,
      default: "",
    },
  },
  components: {},
  data() {
    return {
      itensRank: [],
      loading: true,

      idProgram: "",
    };
  },
  computed: {},
  mounted() {
    this.changeCharts();

    this.idProgram = this.$route.fullPath.split("?")[1];
    if (this.idProgram) {
      this.rankingProgram(this.idProgram);
      return;
    }

    this.$store.getters["getUserType"] == "company"
      ? this.rankingCompany()
      : this.rankingGeral();
  },
  methods: {
    rankingCompany() {
      this.loading = true;

      RankingService.getRankingCompany().then(
        (response) => {
          this.loading = false;
          this.itensRank = response.data.items;    
        },
        () => {
          this.loading = false;
        }
      );
    },
    rankingGeral() {
      this.loading = true;

      RankingService.getRankingGeral(1, 3).then(
        (response) => {
          this.loading = false;
          this.itensRank = response.data.items;
        },
        () => {
          this.loading = false;
        }
      );
    },
    rankingProgram(id) {
      this.loading = true;
      RankingService.getRankingProgram(id).then(
        (response) => {
          this.loading = false;
          this.itensRank = response.data.items;    
        },
        () => {
          this.loading = false;
        }
      );
    },
    async changeCharts() {
      var ctxVisitors = document
        .getElementById("chart-visitors")
        .getContext("2d");

      new Chart(ctxVisitors, {
        // The type of chart we want to create
        type: "line",

        // The data for our dataset
        data: {
          labels: [
            "January",
            "February",
            "March",
            "April",
            "May",
            "June",
            "July",
            "January",
            "February",
            "March",
            "April",
            "May",
            "June",
            "July",
            "January",
            "February",
            "March",
            "April",
            "May",
          ],
          datasets: [
            {
              label: "My First dataset",
              backgroundColor: "transparent",
              borderColor: "#e1e1e1",
              data: [0, 4, 1, 2, 2, 1, 1, 1, 0, 1, 2, 0, 0, 0, 1, 4, 1, 2],
              pointBackgroundColor: [
                "transparent",
                "transparent",
                "transparent",
                "transparent",
                "rgb(23,171,19)",
              ],
              pointBorderColor: [
                "transparent",
                "transparent",
                "transparent",
                "transparent",
                "rgb(23,171,19)",
              ],
              pointBorderWidth: 0,
              borderWidth: 1.5,
              pointRadius: 0,
            },
          ],
        },

        // Configuration options go here
        options: {
          responsive: true,
          maintainAspectRatio: false,
          spanGaps: false,
          layout: {
            padding: {
              left: 0,
              right: 0,
              top: 0,
              bottom: 0,
            },
          },
          elements: {
            line: {
              tension: 0.000001,
            },
            point: {
              radius: 5,
            },
          },
          legend: {
            display: false,
          },
          scales: {
            yAxes: [
              {
                gridLines: {
                  display: false,
                  drawBorder: false,
                },
                ticks: {
                  beginAtZero: false,
                  display: false,
                },
              },
            ],
            xAxes: [
              {
                gridLines: { display: false, drawBorder: false },
                ticks: { beginAtZero: false, display: false },
              },
            ],
          },
        },
      });
    },
  },
};
</script>
